import { defineComponent as _defineComponent } from 'vue'
import {
  Modal,
  Heading,
  BaseText,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { IAmountDetails } from '@/modules/trade/services/margin-allocation';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BannerAction } from '@/modules/trade/services/margin-allocation';
import { useRouter } from 'vue-router/composables';

interface Props {
  isOpen: boolean;
  data: IAmountDetails;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsModal',
  props: {
    isOpen: { type: Boolean },
    data: null
  },
  setup(__props: any) {



const router = useRouter();

const handleBannerAction = (action: BannerAction) => {
  switch (action) {
    case BannerAction.GO_TO_AMW_CASH_CLASH:
      router.push({
        name: 'productsCatalog',
        params: {
          type: 'funds',
          productId: 'c9c94d27-9f23-11ec-929c-0aae9b4e6433'
        }
      });
      break;
  }
};

return { __sfc: true,router, handleBannerAction, Modal, Heading, BaseText, ListDisplay, ButtonPrimary, NebraskaColors }
}

})